import { render } from "./OTPControl.vue?vue&type=template&id=45d005a8"
import script from "./OTPControl.vue?vue&type=script&lang=js"
export * from "./OTPControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__